import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/images/logo-genesis-2x.png'
import _imports_1 from '@/app/ui/assets/svg/deadline-expired.svg'


const _hoisted_1 = { class: "bg-gray-lp-100 h-full min-h-screen w-screen justify-start items-center flex flex-col font-montserrat px-8" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-64 mt-8 absolute mx-auto",
  alt: "logo"
}, null, -1)
const _hoisted_3 = { class: "bg-gray-lp-100 h-full min-h-screen w-screen justify-center items-center flex flex-col" }
const _hoisted_4 = { class: "flex flex-col w-full max-w-2xl text-12px xxl:text-14px text-center justify-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "expired"
}, null, -1)
const _hoisted_6 = { class: "font-bold text-black-lp-100 text-28px lg:text-36px xxl:text-42px py-4" }
const _hoisted_7 = { class: "text-12px xxl:text-14px text-gray-lp-300 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("forgotPassword.expired.title")), 1),
          _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("forgotPassword.expired.body")), 1),
          _createVNode(_component_Button, {
            "data-testid": "auth-forgot-password-expired-button-back",
            title: _ctx.$t('forgotPassword.expired.backButton'),
            custom: "px-12 bg-red-lp-200",
            onClick: _ctx.onHome
          }, null, 8, ["title", "onClick"])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}